import { useTranslate } from '@repo/shared/hooks'
import { z } from 'zod'

export const useDepositOnlinePaymentSchema = (isCardRequired = true) => {
  const { t } = useTranslate()
  const schema = z.object({
    card: isCardRequired
      ? z
          .string({
            required_error: t('depositOnlinePaymentPage_card_required'),
          })
          .min(1, { message: t('depositOnlinePaymentPage_card_required') })
      : z.string().optional(),

    amount: z
      .string({
        required_error: t('depositOnlinePaymentPage_amount_required'),
        invalid_type_error: t('depositOnlinePaymentPage_amount_invalid'),
      })
      .refine(
        (val) => {
          const parsed = parseFloat(val.replace(/,/g, ''))
          return !isNaN(parsed) && parsed >= 2_000
        },
        {
          message: t('depositOnlinePaymentPage_amount_min'),
        },
      ),
  })
  return { schema }
}

export type DepositOnlinePaymentFormValues = z.infer<
  ReturnType<typeof useDepositOnlinePaymentSchema>['schema']
>
